// extracted by mini-css-extract-plugin
export default {"table":"VersionInfoDialog_table__z-LGp","tableRow":"VersionInfoDialog_tableRow__6j-q5","tableCell":"VersionInfoDialog_tableCell__BfZTX","link":"VersionInfoDialog_link__YKlaQ"};